"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupValueWidget = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var journey_model_1 = require("@athena-portal/journey-model");
var OutputWidgetBase_1 = require("./OutputWidgetBase");
var journey_services_1 = require("@athena-portal/journey-services");
var LookupValueWidget = exports.LookupValueWidget = /** @class */ (function (_super) {
    __extends(LookupValueWidget, _super);
    function LookupValueWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            serviceError: false
        };
        return _this;
    }
    LookupValueWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.lookupService
            .fetchLookupValues(this.getSetting("classifier"), "en-UK")
            .subscribe(function (lookupValues) {
            _this.setState({ lookupValues: lookupValues });
        }, function () {
            _this.setState({
                serviceError: true
            });
        });
    };
    LookupValueWidget.prototype.render = function () {
        var _a;
        var lookupValues = (_a = this.state, _a.lookupValues), serviceError = _a.serviceError;
        if (serviceError) {
            return React.createElement("span", { className: "text-danger" }, "Service error");
        }
        if (lookupValues) {
            var id_1 = journey_services_1.ExpressionEvaluator.evaluateExpression(this.getSetting("classifierValueField"), this.props.interaction, "");
            var item = lookupValues.find(function (v) { return v.id === id_1; });
            if (item) {
                return item.value;
            }
        }
        return React.createElement(React.Fragment, null);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LookupValueWidget.prototype, "lookupService", void 0);
    LookupValueWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "classifier", type: journey_model_1.TypeDescriptions.String },
            { name: "classifierValueField", type: journey_model_1.TypeDescriptions.String },
        ]),
        (0, journey_model_1.questionConfiguration)({
            noChildren: true,
            noPlaceholder: true,
            noLabel: true,
            noInteractionField: true,
            noValidations: true
        }),
        __metadata("design:paramtypes", [Object])
    ], LookupValueWidget);
    return LookupValueWidget;
}(OutputWidgetBase_1.OutputWidgetBase));
//# sourceMappingURL=LookupValueWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/output/LookupValueWidget.js
// module id = 2383
// module chunks = 0